import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function UrgencyBar() {
  return <div className="bg-orange-600 text-white py-2 px-4 text-center font-bold text-xs md:text-sm tracking-wider uppercase flex items-center justify-center gap-2" data-id="element-190">
      <AlertTriangle className="w-4 h-4 fill-white text-orange-600" data-id="element-191" />
      <span data-id="element-192">Just For Today: $6.39 (68% OFF)</span>
      <AlertTriangle className="w-4 h-4 fill-white text-orange-600" data-id="element-193" />
    </div>;
}